import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { loadRuntimeConfig } from './runtime-config'

// The stage's settings (/config.json) must be loaded before the app's modules
// (Amplify config, API client) read them, so the app is imported afterwards.
void loadRuntimeConfig().then(async () => {
  const { default: App } = await import('./App.tsx')
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
